import React, { useState } from 'react';
import zxcvbn from 'zxcvbn';

const labelsObj = {
    0: 'Very weak',
    1: 'Weak',
    2: 'Fair',
    3: 'Good',
    4: 'Strong',
};

const progressColorObj = {
    0: '#828282',
    1: '#EA1111',
    2: '#FFAD00',
    3: '#9bc158',
    4: '#00b500',
};

const PasswordStrengthMeter = ({ password, strengthScore }) => {
    const testResult = zxcvbn(password);
    const num = testResult.score * 100;

    const [label, setLabel] = useState('');
    const [progressColor, setProgressColor] = useState('none');

    React.useEffect(() => {
        setLabel(labelsObj[testResult.score * 4]);
        setProgressColor(progressColorObj[testResult.score * 4])
        strengthScore(testResult.score * 4);
    }, [password])

    const style = {
        width: `${num}%`,
        background: progressColor,
        height: '7px'
    }

    return (
        <>
            <div className="progress" style={{ height: '7px' }}>
                <div className="progress-bar" style={style}></div>
            </div>
            <p style={{ color: progressColor }} className="text-right">{label}</p>
        </>
    )
}

export default PasswordStrengthMeter;